import { render, staticRenderFns } from "./pkgHistory.vue?vue&type=template&id=76757c54&scoped=true&lang=html&"
import script from "./pkgHistory.vue?vue&type=script&lang=js&"
export * from "./pkgHistory.vue?vue&type=script&lang=js&"
import style0 from "./pkgHistory.vue?vue&type=style&index=0&id=76757c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76757c54",
  null
  
)

component.options.__file = "pkgHistory.vue"
export default component.exports